function sendVerificationEmailAndCloseAlert(evt, data, successMessage) {
	sendVerificationEmail(evt, data, successMessage, function () {
		closeAlert($(evt.target).closest('.alert')[0]);
	});
}

function sendVerificationEmail(evt, data, successMessage, closeAction) {
	Loading.on(evt.target);
	dataAction.sendVerificationEmail(data, function (data) {
		showSuccessPopup(successMessage, closeAction);
	}, function (error) {
		var errorText = JSON.parse(error.responseText);

		var message = errorText['error'];
		if (errorText['message']) {
			message = errorText['message'];
		}

		showErrorPopup(message);
	}, function () {
		Loading.off(evt.target);
	});

	return false;
}